export enum ClvPromptActionPriority {
  HIGHT, LOW
}
